import { Box, LinearProgress, Paper, Stack, Typography } from '@mui/material';
import { DashboardStats } from '../../types/dashboard';

interface LeadSourcesCardProps {
  stats?: DashboardStats;
}

export const LeadSourcesCard = ({ stats }: LeadSourcesCardProps) => {
  const total = stats?.totalLeads ?? 0;
  const known = (stats?.facebookLeads ?? 0) + (stats?.whatsappLeads ?? 0) + (stats?.telephoneLeads ?? 0);
  const other = Math.max(total - known, 0);

  const rows = [
    { label: 'Facebook', value: stats?.facebookLeads ?? 0, color: '#1877F2' },
    { label: 'WhatsApp', value: stats?.whatsappLeads ?? 0, color: '#25D366' },
    { label: 'Telephone', value: stats?.telephoneLeads ?? 0, color: '#F5A623' },
    { label: 'Other sources', value: other, color: '#8354C6' },
  ];

  return (
    <Paper sx={{ p: 2, height: '100%' }}>
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        Lead sources
      </Typography>
      <Stack spacing={2}>
        {rows.map((row) => {
          const pct = total > 0 ? Math.round((row.value / total) * 100) : 0;
          return (
            <Box key={row.label}>
              <Stack direction="row" justifyContent="space-between" sx={{ mb: 0.5 }}>
                <Typography variant="body2">{row.label}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {row.value} · {pct}%
                </Typography>
              </Stack>
              <LinearProgress
                variant="determinate"
                value={pct}
                sx={{
                  height: 8,
                  borderRadius: 4,
                  bgcolor: 'action.hover',
                  '& .MuiLinearProgress-bar': { bgcolor: row.color, borderRadius: 4 },
                }}
              />
            </Box>
          );
        })}
      </Stack>
    </Paper>
  );
};
